module.exports = __webpack_public_path__ + "img/icon3.dce6270a.png";